
<template>
  <section class="blogs-component-mag-details pt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="d-flex my-4" v-if="!isLoading">
      <div class="col-md-12">
        <img class="card-img-box" :src="appUrl.media +'/'+ magDetails.img">
        <div class="float-right">

        <div class="card flex-md-row-reverse mb-4 box-shadow h-md-250">
          <div class="card-body d-flex flex-column align-items-start">
            <strong
              class="d-block mb-2 text-secondary rtl text-right"
            >نویسنده : {{magDetails.fullname}}</strong>
            <strong class="d-inline-block mb-2 text-primary rtl text-right">{{magDetails.title}}</strong>
            <div class="mb-1 text-muted d-flex align-items-center justify-content-center">
              <i class="flaticon-calendar icon-18 ml-1"></i>
              <span class="font-14">{{magDetails | date}}</span>
            </div>
            <p class="card-text mb-auto content-html" v-html="magDetails.content"></p>
          </div>
        </div>
        </div>

      </div>
    </div>
    <div v-else>
      <!-- TODO handel style loader -->
      <content-loader :height="150" :speed="2" :animate="true"></content-loader>
    </div>
  </section>
</template>

<script>
export default {
  name: "blogs-component-mag-details",
  data() {
    return {
      isLoading: true,
      magDetails: {}
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getMagsDetails();
  },
  methods: {
    async getMagsDetails() {
      try {
        let { data } = await axios.post("/blog/get-post-detail", {
          Id: parseInt(this.id)
        });
        if (data.state != 200) return;
        this.magDetails = data.detail[0];
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.blogs-component-mag-details {
  .box-clear;
  .card-img-box{
    float: right;
    max-width: 100%
  }
  .card {
    img {
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog/details.vue